import { reatomAsync } from "@reatom/async";
import { TelegramAuthRequestDto } from "definitions/poizon-sso";
import { API } from "src/api";

import { getMeTelegramRequest } from "./getMeTelegram";

export const signUpTelegramRequest = reatomAsync(
  (_ctx, data: TelegramAuthRequestDto) => {
    return API.telegramApi
      .telegramControllerSignupTelegram(data)
      .then((response) => response.data);
  },
  {
    name: "signUpTelegram",
    onFulfill: (ctx) => {
      getMeTelegramRequest(ctx);
    },
  },
);
